export default "__VITE_PUBLIC_ASSET__dac6c632__"